import React, { FC, PropsWithChildren } from 'react';
import { IntercomProvider as IntercomProviderDefault } from 'react-use-intercom';
import { INTERCOM_APP_ID } from 'src/constants';
import app from 'srcJs/App';
import { useUserData } from 'components/user/hooks/use-user-data';

const IntercomProvider: FC<PropsWithChildren<any>> = ({
  children,
}) => {
  if (!app.getExternalApp().isEnableIntercom()) {
    return children;
  }

  const userData = useUserData();

  return (
    <IntercomProviderDefault
      appId={INTERCOM_APP_ID}
      autoBoot
      autoBootProps={{
        userId: String(userData.id),
        name: userData.fullName,
        email: userData.email,
        createdAt: String(userData.createdAt),
      }}
    >
      {children}
    </IntercomProviderDefault>
  );
};

export { IntercomProvider };
